import { useMemo } from 'react';

import { permissions, strings } from 'common';
import Button from 'components/shared/Button';
import PermissionsGate from 'components/shared/PermissionsGate';
import { Task, TaskStatus } from 'models';
import { canDenyTask } from 'utils/tasks';

interface DenyButtonProps {
  selectedIds: string[];
  tasks: Task[];
  loading: boolean;
  onClick: (status: TaskStatus) => void;
}

const DenyButton: React.FC<DenyButtonProps> = (props) => {
  const { selectedIds, tasks, loading, onClick } = props;

  const disabled = useMemo(() => {
    if (!selectedIds.length) {
      return true;
    }
    return !selectedIds.every((id) => {
      const task = tasks.find((task) => task.id === id);
      return canDenyTask(task!);
    });
  }, [selectedIds, tasks]);

  return (
    <PermissionsGate permissions={[permissions.INVENTORY_VDP_TASKS_APPROVE]}>
      <Button
        className="FlatTasks-action-button FlatTasks-action-button-deny"
        id="deny-task-button"
        type="button"
        variant="danger"
        onClick={() => onClick('DENIED')}
        disabled={disabled}
        loading={loading}
      >
        {strings.DENY}
      </Button>
    </PermissionsGate>
  );
};

export default DenyButton;
